import React from 'react'
import BasicProject from './BasicProject'
import EasyCalc from "../assets/image/project-ss/EasyCalc.png";
import WeatherApp from "../assets/image/project-ss/WeatherApp.png";
import analogClock from "../assets/image/project-ss/analogClock.png";
import imageSearching from "../assets/image/project-ss/imageSearching.png";
import imageSlider from "../assets/image/project-ss/imageSlider.png";
import imageSlider2 from "../assets/image/project-ss/imageSlider2.png";
import quizeapp from "../assets/image/project-ss/quizeapp.png";
import quotesgenerator from "../assets/image/project-ss/quotesgenerator.png";
import sidebar from "../assets/image/project-ss/sidebar.png";
import Education from './Education';
import MusicPlayer from "../assets/image/project-ss/advance_projects_ss/musicPlayer.png"
import hbwebsite from "../assets/image/project-ss/advance_projects_ss/1.png"
import newsapp from "../assets/image/project-ss/advance_projects_ss/newsapp.png"
import AdvanceProject from './AdvanceProject';
import imageGenerator from "../assets/image/project-ss/advance_projects_ss/imageGenerator.png";
import youtubelite from "../assets/image/project-ss/advance_projects_ss/youtube-lite.png";
import Skill from './Skill';

export default function Resume() {
    document.title = "Portfolio - RESUME"

    return (
        <section className="resume-content">
            <h2 className="after-line">Resume</h2>
            <div className="resume">
                <h2 className="after-line">Skills</h2>
                <div className="skills-graph">
                    <Skill
                        skillname="java core"
                        percentage="75"
                    />
                    <Skill
                        skillname="jsp"
                        percentage="65"
                    />
                    <Skill
                        skillname="jdbc"
                        percentage="63"
                    />
                    <Skill
                        skillname="css"
                        percentage="81"
                    />
                    <Skill
                        skillname="javascript"
                        percentage="70"
                    />
                    <Skill
                        skillname="bootstrap"
                        percentage="60"
                    />

                    <Skill
                        skillname="html"
                        percentage="80"
                    />

                    <Skill
                        skillname="sql"
                        percentage="70"
                    />
                    <Skill 
                    skillname="jquery"
                    percentage="60"
                    />
                    <Skill 
                    skillname="php"
                    percentage="61"
                    />
                    <Skill 
                    skillname="Data structures and algorithms"
                    percentage="60"
                    />
                    <Skill 
                    skillname="C#"
                    percentage="50"
                    />
                    <Skill 
                    skillname="ASP.NET"
                    percentage="63"
                    />

                </div>
            </div>
            <h1 className="summary">Summary</h1>
            <div className="summary-content">
                <h4 className="leftside-line">Adarsh Maurya</h4>
                <p>I am a computer programmer and i am fascinated by the application of data structures and algorithms in
                    the
                    real-life problems. I am targeting a role to make me more confident about applying the knowledge to
                    industry
                    level problems and unleashing my full potential to add value to the company.</p>
                <ul>
                    <li>New Delhi, 110062</li>
                    <li>adarshmaurya0022@gmail.com</li>
                </ul>
            </div>
            <h1 className="summary">Education</h1>
            <div className="summary-content">
                <Education
                    degreeName="Computer Science And Engineering (BCA)"
                    session="January 2021 - December 2023"
                    universityName="INDIRA GANDHI NATIONAL OPEN UNIVERSITY (IGNOU), New Delhi"
                    percentage="Complete"
                    percentageMark="71.18"
                    tillYear="5th Semester"
                />
                <Education
                    degreeName="Higher secondary"
                    session="2020"
                    universityName="Krishna pal singh intermediate college (kpsic), pratapgarh, uttar paradesh"
                    percentage=""
                    percentageMark="66"
                />
                <Education
                    degreeName="High school"
                    session="2018"
                    universityName="Krishna pal singh intermediate college (kpsic), pratapgarh, uttar paradesh"
                    percentage=""
                    percentageMark="69"
                />
            </div>
            <h1 className="summary">Projects</h1>
            <div className="summary-content">
                <h4 className="leftside-line">Basic Projects</h4>
                <div className="all-projects">
                    <div className="row">
                        <BasicProject thumbnail={EasyCalc} heading="EasyCalc Calculator"
                            content="I created a basic calculator using HTML, CSS, and JavaScript to perform simple arithmetic
                        operations effortlessly."
                            demoLink="https://adarshmaurya54.github.io/EasyCalc/"
                            githubLink="https://github.com/adarshmaurya54/EasyCalc"
                        />
                        <BasicProject thumbnail={imageSearching} heading="Image Search Engine using JavaScript"
                            content="I've created a website where you can search and download images. It's an amazing project
                        I'm proud of."
                            demoLink="https://adarshmaurya54.github.io/Search-Image-using-JavaScript/"
                            githubLink="https://github.com/adarshmaurya54/Search-Image-using-JavaScript"
                        />
                        <BasicProject thumbnail={WeatherApp}
                            heading="Weather App"
                            content="I've developed a weather app for city-based weather updates. Retrieve weather info by
                        inputting city names."
                            demoLink="https://adarshmaurya54.github.io/weatherapp/"
                            githubLink="https://github.com/adarshmaurya54/weatherapp"
                        />
                        <BasicProject thumbnail={quizeapp}
                            heading="Quize App"
                            content="Crafted a quiz web app using HTML, CSS, and JS, showcasing my coding prowess. Engaging
                        user experience meets interactive learning. Proud of the achievement!"
                            demoLink="https://adarshmaurya54.github.io/QuizeApp/"
                            githubLink="https://github.com/adarshmaurya54/QuizeApp"
                        />
                        <BasicProject thumbnail={quotesgenerator}
                            heading="Quotes Generator"
                            content="Crafted a dynamic quote generator with HTML, CSS, and JavaScript. Automatically refreshes
                        every 30 seconds, inspiring users with fresh wisdom."
                            demoLink="https://adarshmaurya54.github.io/QuotesGenerator/"
                            githubLink="https://github.com/adarshmaurya54/QuotesGenerator"
                        />
                        <BasicProject thumbnail={sidebar}
                            heading="Stylish Sidebar"
                            content="Crafted a chic sidebar with HTML, CSS, and JS, merging elegance and functionality for an
                        engaging user experience. Stylish design meets seamless interaction."
                            demoLink="https://adarshmaurya54.github.io/StylishSidebar/"
                            githubLink="https://github.com/adarshmaurya54/StylishSidebar"
                        />
                        <BasicProject thumbnail={analogClock}
                            heading="Analog Clock"
                            content="I've crafted an analog clock showcasing real-time date and time through HTML, CSS, and
                        JavaScript, merging aesthetics with functionality seamlessly for an informative and
                        visually appealing experience."
                            demoLink="https://adarshmaurya54.github.io/analogClock/"
                            githubLink="https://github.com/adarshmaurya54/analogClock"
                        />
                        <BasicProject thumbnail={imageSlider}
                            heading="Image Slider(Carousel)"
                            content="Built a custom image slider using HTML, CSS, and JavaScript from the ground up,
                        showcasing my coding skills and creativity."
                            demoLink="https://adarshmaurya54.github.io/ImageSlider/"
                            githubLink="https://github.com/adarshmaurya54/ImageSlider"
                        />
                        <BasicProject thumbnail={imageSlider2}
                            heading="Image Slider2"
                            content="Crafted another exquisite image slider with HTML, CSS, and JS, seamlessly blending captivating visuals and smooth transitions for an engaging user experience. Elegance in motion."
                            demoLink="https://adarshmaurya54.github.io/ImageSlider2/"
                            githubLink="https://github.com/adarshmaurya54/ImageSlider2"
                        />
                    </div>
                </div>
                <h4 className="leftside-line mt">Advance projects</h4>
                <div className="all-projects">
                    <div className="row adv-projs">
                        <AdvanceProject
                            thumbnail={MusicPlayer}
                            heading="Music Player"
                            content="I've created a music player using HTML, CSS, and JavaScript. It's a harmonious blend of design and functionality, offering an immersive musical experience. Play your favorite tunes with ease while enjoying a visually pleasing interface that I've crafted from scratch."
                            demoLink="https://adarshmaurya54.github.io/MusicPlayer/"
                            githubLink="https://github.com/adarshmaurya54/MusicPlayer/"
                        />
                        <AdvanceProject
                            thumbnail={hbwebsite}
                            heading="Hotel Booking Website"
                            content={
                                <>
                                    🚀 Hotel Booking Website Project in PHP 🚀<br /><br />
                                    I am excited to share my latest web development project, a feature-rich hotel booking website developed in PHP. 🏨✨<br /><br />

                                    Key Features:<br /><br />
                                    ✔️ User registration with email verification for enhanced security.<br />
                                    🔄 Password reset system with email notifications for user convenience.<br />
                                    💳 Integration of the Razorpay payment gateway for secure online transactions.<br />
                                    🚀 Improved performance using AJAX for efficient data retrieval.<br />
                                    🔒 Robust password hashing techniques to ensure data security.<br />
                                    🔍 Live searching functionality in the admin panel for real-time data management.<br />
                                    📄 Pagination in the admin panel for streamlined data handling and navigation.<br /><br />

                                    This was an amazing project that challenged my skills and creativity, and I'm thrilled with the results it has achieved.<br /><br />

                                    Web Development Stack:<br /><br />
                                    💻 PHP<br />
                                    🌐 HTML, CSS, JavaScript<br />
                                    📦 MySQL Database<br />
                                    🛠 AJAX for Performance Optimization<br />
                                    💳 Razorpay Payment Gateway<br />
                                </>
                            }
                            demoLink=""
                            githubLink="https://github.com/adarshmaurya54/HotelBookingWebsite"
                        />
                        <AdvanceProject
                            thumbnail={newsapp}
                            heading="NewsApp"
                            content="Discover the latest news with our React-based news application, powered by the GNews API. Stay informed and up-to-date with real-time news updates in a user-friendly interface. Experience a seamless and responsive news browsing experience, all at your fingertips."
                            demoLink="https://mylatestnews.vercel.app/"
                            githubLink="https://github.com/adarshmaurya54/NewsApp/"
                        />
                        <AdvanceProject
                            thumbnail={imageGenerator}
                            heading="AI Image Generator"
                            content="I've developed a React web app powered by an API that generates images. Users can create and customize images with ease, offering a dynamic visual experience."
                            demoLink="https://adarshmaurya54.github.io/ImageGenerator/"
                            githubLink="https://github.com/adarshmaurya54/ImageGenerator/"
                        />
                        <AdvanceProject
                            thumbnail={youtubelite}
                            heading="YouTube Lite"
                            content="I crafted a streamlined YouTube Lite web app using React, seamlessly integrated with the YouTube API. Experience the essence of YouTube with a faster, more efficient interface. Enjoy video content without the bulk, as my application optimizes the viewing experience while maintaining functionality. Discover the simplicity of my creation!"
                            demoLink="https://utube-lite.vercel.app/"
                            githubLink="https://github.com/adarshmaurya54/YouTube_Clone/"
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}
